/**
 * Home Footer Component
 * Footer for the landing page
 */

import { Box, Container, Typography, useTheme } from '@mui/material';

export default function HomeFooter() {
  const theme = useTheme();

  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        backgroundColor: 'background.paper',
        borderTop: 1,
        borderColor: 'divider',
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1,
            textAlign: 'center',
          }}
        >
          <Typography variant="body2" color="text.secondary">
            © {currentYear}, BNFT - Bureau National de Fret Terrestre
          </Typography>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
            }}
          >
            <Typography variant="body2" color="text.secondary">
              based on
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: theme.palette.secondary.main, fontWeight: 600 }}
            >
              ROADE
            </Typography>
            <Typography variant="body2" color="text.secondary">
              by
            </Typography>
            <a href="https://www.servoo.cm/" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center' }}>
              <img src="/images/servoo.png" alt="Servoo" style={{ height: 20, marginLeft: 4 }} />
            </a>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
